/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class OntologyEntityItem {
    getFixupPrototypeFunction() { return OntologyEntityItem.fixupPrototype; }

    static newInstance(model: Partial<OntologyEntityItem>): OntologyEntityItem {
        let obj = Object.assign(new OntologyEntityItem(), model);
        OntologyEntityItem.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<OntologyEntityItem>): OntologyEntityItem {
        if (!model) return null;
        return OntologyEntityItem.newInstance(<OntologyEntityItem> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: OntologyEntityItem) {
        if (!obj) return;

        models.OntologyEntityItem.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: OntologyEntityItem): boolean {
        Object.setPrototypeOf(obj, OntologyEntityItem.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Detail node identifier — submit verbatim as node_id on /node to fetch this entity's full detail
     */
    id: string;

    /**
     * Short display value for the list row; absent when the entity has no name-like property populated
     */
    label: string;

    /**
     * Projected fields for this entity, shape varies by entity_type
     */
    properties: { [key: string]: any; };

}
